module.exports = __webpack_public_path__ + "static/media/impressum.392f3ecf.pdf";